import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import { enqueueSnackbar } from '../../../components/GlobalSnackbar/snackbarStore';
import { keys } from './keys';

type Variables = {
  memberId: string;
  spaceId: string;
};

async function deleteSpaceMember(memberId: string) {
  const { error } = await apiClient
    .from('space_members')
    .delete()
    .eq('id', memberId);

  if (error) {
    throw error;
  }
}

export default function useDeleteSpaceMember() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ memberId }: Variables) => deleteSpaceMember(memberId),
    onSuccess: (_data, variables) => {
      enqueueSnackbar('Membre retiré.', 'success');
      queryClient.invalidateQueries({ queryKey: keys.members(variables.spaceId) });
    },
  });
}
